import React, { useState, useCallback, useEffect } from 'react';
const PeFormWizard = ({ order, pages, page = 0, formik, autoComplete = true }) => {
    const [currentPage, setCurrentPage] = useState(page);
    const stepsOrder = order !== null && order !== void 0 ? order : Object.keys(pages);
    const currentPageName = stepsOrder[currentPage];
    const Page = pages[currentPageName];
    useEffect(() => {
        // eslint-disable-next-line  @typescript-eslint/no-floating-promises
        formik.validateForm();
    }, []);
    const handleSubmit = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        Object.keys(formik.values[currentPageName]).map((field) => formik.setFieldTouched(`${currentPageName}.${field}`, true));
        if (!formik.errors[currentPageName]) {
            return currentPage === stepsOrder.length - 1 ? formik.handleSubmit() : setCurrentPage(currentPage + 1);
        }
        return false;
    }, [currentPage, currentPageName, formik, stepsOrder.length]);
    const handleBack = useCallback(() => setCurrentPage(Math.min(Math.max(currentPage - 1, 0), stepsOrder.length - 1)), [currentPage, stepsOrder.length]);
    const wizardMethods = {
        page: currentPage,
        pages: Object.keys(pages).length,
        isFirstPage: currentPage === 0,
        isLastPage: currentPage === stepsOrder.length - 1,
        handleBack,
        stepsOrder,
    };
    const step = Page({ wizardMethods, formik });
    return (React.createElement("form", { onSubmit: (event) => {
            event.preventDefault();
            handleSubmit();
        }, autoComplete: autoComplete ? 'on' : 'off' }, step));
};
export default PeFormWizard;
